import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
//import { useSearchParams } from 'react-router-dom'
import moment from "moment"
//import { useNavigate,useParams,useLocation,useHistory } from "react-router-dom";
import {  useLocation, useHistory } from "react-router-dom";
import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import $ from 'jquery';
//import {  BrowserRouter as Router, Link,  useLocation} from "react-router-dom";


//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const EditJobLocation: FC = () => {
      const intl = useIntl()
      let history = useHistory();
      const [locationInfo, setLocationInfo] = useState([]);
      const red="red";
      const location99 = useLocation();
     const queryParams99 = new URLSearchParams(location99.search);
      const locationId = queryParams99.get('locationId');
      const locationName = queryParams99.get('name');
      const {
        register,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

      
      function getJobLocationById(){
          services.getJobLocationsById(locationId).then((res) => 
          {
            const myres = JSON.stringify(res);
            console.log(res.data.name);
            if(res){     
              $('#country_name').val(res.data.name);            
            setLocationInfo(res.data); 
              //lert(res.data.eventTitle)
              //$("#eventTitle").val(res.data.eventTitle);  
            }  
          });
       }
      const submitValue = () => {
        var validateEditorTxt = 1;
        if($('#country_name').val() == ""){
          $("#countyNameValidMsg").show();  
          $(window).scrollTop($('#countyNameValidMsg').position().top);
          validateEditorTxt = 0;     
        }else{
          $("#countyNameValidMsg").hide();  
        }

        if(validateEditorTxt == 0){
          return false;
         }
            
        const requestObject={
            "jobLocationCountyId":locationId,
            "name":$("#country_name").val(),
            "siteId":"2"
        }
        console.log(requestObject);
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json',
                    //'Authorization': "Bearer "+accessTokenIn 
                    //'Authorization': accessTokenIn 
                  },
          body: JSON.stringify(requestObject)
        };

        services.udpateadminJobLocationCounty(requestOptions).then((res) => 
        {
          if (res.code == '200') {
            $("#editlocationsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editlocationsuccessMessage").slideUp(500);
            });
            setTimeout(() => {
              history.push('/joblocationcountrylist');
            }, 1000);
          }
          else{
            $("#editlocationfailMessage").fadeTo(2000, 500).slideUp(500, function () {
              $("#editlocationfailMessage").slideUp(500);
            });
            setTimeout(() => {
              
            }, 1000);
          }
        });
        
      }
      useEffect(() => 
      {     
        $('#countyNameValidMsg').hide(); 
        //$('#country_name').val(locationName);
        $("#editlocationsuccessMessage").hide();
        $('#editlocationfailMessage').hide();
       getJobLocationById();
      },[]);
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Edit Job Location County'})}</PageTitle>
         
          <form   onSubmit={handleSubmit(submitValue)}>     
             <div className="container">
               <div className="row">
                 

                 <div className="col-lg-12">
                 <div className="mb-4">
                 <div className="d-flex flex-column ">
                 <label htmlFor="exampleFormControlInput1" className="required form-label">County Name</label>
                 
                 </div>
                  <input type="text" id="country_name" name="country_name" className="form-control"  />
                  <div id="countyNameValidMsg" style={{color:red}} className="error">County Name is required.</div>
              </div>
                 </div>
                
                
                 <div className="col-lg-12">
                 <div className="mb-5 px-3">
                 <div className="d-flex flex-column ">
                 <div className="row mt-2">
                    <div className="divider"></div>
                    <button type="submit" className="btn btn-primary mt-10" style={{maxWidth: "200px"}}> Update County </button>
                 </div>
                 </div>
                 <div id="editlocationsuccessMessage" className="alert alert-success" role="alert">County Updated Successfully</div>
                 <div id="editlocationfailMessage" className="alert alert-danger" role="alert">Please try again</div>
              </div>
                 </div>

               </div>
             </div>
             </form>
        </>
      )
    }
export {EditJobLocation}